import { Button, NavLink } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Layout from "template";
import { MenuItems } from "template/MenuItems";
import { DashboardCard } from "./DasboardCard";
import { PranthaSthayiCard } from "./PranthaSthayiCard"
import { Link } from "react-router-dom";
import axios from "axios";
import { APIService } from "services";
// import { JillaReportCard } from "components/jilla_reports/JillaReportsCard";
import {
  useParams
} from "react-router-dom";


export const Dashboard: React.FC = () => {
  const [vibhagCount, setVibhagCount] = useState([]);
  // const [id,setId] =useState<number>(0)
  const [pranthaCount, setPranthaCount] = useState([]);

  const { vibhag_id } = useParams();
  // let 
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    let DesignationId = localStorage.getItem("desig_level_id")
    let payload;
    if (DesignationId === "2") {
      payload = {
        type: "sambhag",
        type_id: "",
      };
    } else if (DesignationId === "3") {
      payload = {
        type: "vibhag",
        type_id: "",
      };
    } else {
      payload = {
        type: "vibhag",
        type_id: "",
      };
    }
    // .post(`/survey_results/mandal_survey_count/`,{id}).then((resp) => {

    setIsLoading(true);
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", payload).then((response) => {
      console.log("16responsevibhagscreen", response.data.SamithiReport)
      let vibhagData = response.data.SamithiReport;
      let array = [];
      array.push(response.data.SamithiReport[0])
      if (array && array.length > 0) {
        const filteredArray = array.filter(item => item !== undefined);
        setIsLoading(false);
        setPranthaCount(filteredArray)
      }
      // console.log("24vibhagCount",filteredArray)
      setVibhagCount(vibhagData)
      // let id= localStorage.setItem("vibhag_id",response.data.SamithiReport.id)
    }).catch((err) => {
      console.log(err)
    })
  }, [1000])
  // console.log("id29",vibhag_id)
  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))
  console.log("id29", typeof (DesignationId))

  let MemberName = localStorage.getItem('member_name')
  // console.log("35MemberName", MemberName)
  return (
    <Layout>
      <div className="container-fluid" >
        <div className="d-sm-flex align-items-center justify-content-between mb-4" >
          {/* <h1 className="h3 mb-0 text-gray-800" > Vibhags </h1> */}
        </div>
        <div className="h5 mb-0 font-weight-bold text-gray-800">
          <p>Namasthe, {MemberName} 🙏</p></div>

        <div className="d-flex flex-column min-vh-100" >
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            <Row>
              {(DesignationId === 1 || DesignationId === 2) && pranthaCount.length > 0 && pranthaCount.map((item, i) => {
                return (<><PranthaSthayiCard key={`Card-${i}`} id={item.id} vibhag_name={item.vibhag_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti_count={item.total_basti_count} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} total_samithi_formed={item.total_samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
                </>)
              })}
            </Row>
          }
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            (
              <Row>
                {vibhagCount.length > 0 && vibhagCount.map((item, i) => {
                  return (<><DashboardCard key={`Card-${i}`} id={item.id} vibhag_name={item.vibhag_name} gramas_formed={item.gramas_formed} samithi_formed={item.samithi_formed} total_basti_count={item.total_basti_count} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} total_samithi_formed={item.total_samithi_formed} total_basti={item.total_basti} total_gramas={item.total_gramas} />
                  </>)
                })}
              </Row>
            )
          }
        </div>

      </div></Layout >
  );
};

